import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerOverlayService {
  private pendingLoads = 0;
  private readonly isLoadingSubject = new BehaviorSubject<boolean>(false);

  readonly isLoading$ = this.isLoadingSubject.asObservable();

  public show(): void {
    this.pendingLoads++;
    if (this.pendingLoads === 1) {
      this.isLoadingSubject.next(true);
    }
  }

  public hide(): void {
    this.pendingLoads = Math.max(0, this.pendingLoads - 1);
    if (this.pendingLoads === 0) {
      this.isLoadingSubject.next(false);
    }
  }
}

